import styled from 'styled-components'
import { IconButton } from '@material-ui/core'

export const DangerIconButton = styled(IconButton)`
	color: ${props => props.theme.tag.red};
`
